import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-global-fetch" id="module-global-fetch"></a>
    <h1 {...{
      "id": "windowfetchinput-init"
    }}>{`window.fetch(input, `}{`[init]`}{`)`}</h1>
    <p>{`Fetches a resource from the network.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Response>`}</inlineCode>{` Promise that resolves to a Response object.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If init.body is set and init.method is either "GET" or "HEAD".`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If either network error or network time-out occurs after a http request is made.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` If there is a failure in reading files in FormData during posting FormData.`}
        <br></br>
In order to leverage `fetch`, update the `manifest.json` with the `network.domains` permission shown below.
        <b>Example:</b>
      </li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "permissions": {
      "network": {
          "domains": [
              "https://www.adobe.com",
              "https://*.adobeprerelease.com",
              "wss://*.myplugin.com"
          ]
      }
  }
}
`}</code></pre>
    <b>Limitation:</b>
From UXP v7.4.0 onwards `permissions.network.domains` does not support WildCards in top-level domains.
    <b>Example:</b>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"domains": [ "https://www.adobe.*", "https://www.*" ]
`}</code></pre>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "./Headers.md"
      }}>{`Headers`}</a>{`, `}<a parentName="p" {...{
        "href": "./Request.md"
      }}>{`Request`}</a>{` and `}<a parentName="p" {...{
        "href": "./Response.md"
      }}>{`Response`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`input`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Request`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Either the URL string to connect with or a Request object having the URL and the init option.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(Optional)`}</inlineCode>{` Custom settings for a HTTP request.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init.method]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`HTTP request method. The default value is "GET".`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init.headers]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Headers`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`HTTP request headers to add.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init.body]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ArrayBuffer`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`TypedArray`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Blob`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`FormData`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`URLSearchParams`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Body to add to HTTP request.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init.credentials]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates whether to send cookies. The default value is "include". Possible values and functions are as follows: `}<ul style={{
              "listStyle": "none"
            }}>{`  `}<li>{`"omit" : cookies are NOT sent.`}</li>{` `}<li>{`"include" : cookies are sent.`}</li>{` `}</ul></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      